import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import EntityIndicatorDialog from '../EntityIndicatorDialog'
import { Divider, Grid } from '@mui/material'
import IndicatorHeaderDialog from '../IndicatorHeaderDialog'
import IndicatorTable from '../IndicatorTable'
import { shallowEqual, useSelector } from 'react-redux'
import { P153_2, VP_183, VP_182 } from 'rpqs/constants/RpqsConstant'
import { getIndicatorDialogRow, updateIndicatorEntity } from 'rpqs/utils/RPQSUtils'
import { round } from 'lodash'

const DialogP153_2 = ({
    open = false,
    setOpen = () => {},
    title = '',
}) => {
    const {
        rpqs,
        managementEntity,
    } = useSelector(store => ({
        rpqs: store.RpqsReducer.rpqs,
        managementEntity: store.CollectivityReducer.managementEntity,
    }), shallowEqual)

    const [entityDialog, setEntityDialog] = useState(managementEntity)

    useEffect(() => {
        setEntityDialog(managementEntity)
    }, [managementEntity])

    const year = rpqs.year
    const previousYear = year-1
    const currentEntity = entityDialog?.[year]

    const formatedIndicators = [
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_182.code,
            indicatorName: i18n[VP_182.i18n],
            unit: '€',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_182.code,
                { ...currentEntity?.[VP_182.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_183.code,
            indicatorName: i18n[VP_183.i18n],
            unit: '€',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_183.code,
                { ...currentEntity?.[VP_183.code], value: parseInt(v) || 0 },
            ))),
        }),
    ]

    const onStatusChange = (status) => {
        setEntityDialog(updateIndicatorEntity(entityDialog, year, P153_2.code, { ...currentEntity?.[P153_2.code], status }))
    }

    const getIndicatorValue = (indicator) => (currentEntity?.[indicator?.code]?.value || 0)

    const calculation = () => {
        const calculatedValue = getIndicatorValue(VP_183) != 0 ? round(getIndicatorValue(VP_182) / getIndicatorValue(VP_183), 2) : 0

        return updateIndicatorEntity(entityDialog, year, P153_2.code, { ...currentEntity?.[P153_2.code], value: calculatedValue })
    }

    return (
        <EntityIndicatorDialog
            open={open}
            setOpen={setOpen}
            title={title}
            hasNote
            entityDialog={entityDialog}
            setEntityDialog={setEntityDialog}
            codeIndicator={P153_2.code}
            calculationOnRegister={calculation}
        >
            <Grid container direction={'column'} gap={2}>
                <IndicatorHeaderDialog
                    current={{
                        year,
                        value: managementEntity?.[year]?.[P153_2.code]?.value,
                    }}
                    previous={{
                        year: previousYear,
                        value: managementEntity?.[previousYear]?.[P153_2.code]?.value,
                    }}
                    status={entityDialog?.[year]?.[P153_2.code]?.status}
                    onStatusChange={onStatusChange}
                    unit={i18n.year}
                />
                <Divider/>
                <IndicatorTable
                    year={year?.toString()}
                    indicators={formatedIndicators}
                />

            </Grid>
        </EntityIndicatorDialog>
    )
}

DialogP153_2.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
}

export default DialogP153_2
